<h4 mat-dialog-title>Select File Types to Download</h4>
<button mat-icon-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <div *ngIf="types.length; else loadingState">
    <div style="margin-bottom: 10px">
      Select: <strong><a (click)="selectAll()">All</a></strong> ·
      <strong><a (click)="selectNone()">None</a></strong>
    </div>
    <mat-selection-list>
      <mat-list-option *ngFor="let type of types" checkboxPosition="before" [selected]="type.selected"
        (click)="toggleSelected(type)">
        <span>{{ type.name }}</span>
        <span class="pull-right">
          {{ type.count }}
          <small>
            <span class="text-muted">file{{ type.count > 1 ? 's' : '' }}</span>
            ({{ convertMbToBytes(type.mb_total) | storageUnit: 2 }})
          </small>
        </span>
      </mat-list-option>
    </mat-selection-list>
    <div style="margin-top: 10px">
      Select: <strong><a (click)="selectAll()">All</a></strong> ·
      <strong><a (click)="selectNone()">None</a></strong>
    </div>
  </div>
  <ng-template #loadingState>
    <div *ngIf="!error; else errorState" class="loading-state">
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    </div>
  </ng-template>
  <ng-template #errorState>
    <div>The items you have selected have no files to be downloaded.</div>
  </ng-template>
</div>
<div mat-dialog-actions align="end">
  <div class="footer-stats" *ngIf="total; else calculatingSize">
    <span class="small-chip">{{ total.files }} files selected</span>
    <span class="small-chip">{{ convertMbToBytes(total.size) | storageUnit: 2 }}</span>
  </div>
  <ng-template #calculatingSize>
    <div class="footer-stats">
      <span>Calculating total size...</span>
    </div>
  </ng-template>
  <button mat-flat-button color="primary" (click)="download()" class="btn-icon" disabled="{{ total?.files < 1 }}"
    test-id="file-download-dialog-submit">
    <mat-icon class="xs">cloud_download</mat-icon>
    Download
  </button>
</div>
